const mockApi = (data, options = {}) => {
  const { success = true } = options;
  return new Promise((resolve, reject) => {
    if (success) {
      resolve({ data });
    } else {
      reject({ data });
    }
  });
};

export default mockApi;
